"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFrameComponent = _interopRequireDefault(require("react-frame-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class IframeChildren extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {});

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.children !== prevProps.children) {
        this.getHead();
      }
    });

    _defineProperty(this, "iframeDidMount", () => {
      this.getHead();
    });

    _defineProperty(this, "getHead", () => {
      let stylesheets = [],
          styles = [];
      const linkTags = document.head.querySelectorAll('[rel="stylesheet"]');
      const styleTags = document.head.getElementsByTagName("style");

      for (let i = 0; i < linkTags.length; i++) {
        let styleheet = linkTags[i].getAttribute('href');
        stylesheets.push(styleheet);
      }

      for (let i = 0; i < styleTags.length; i++) {
        let style = styleTags[i].innerHTML;
        styles.push(style);
      }

      let head = [];

      if (this.props.style) {
        head.push(_react.default.createElement("style", null, this.props.style));
      } else {
        stylesheets.forEach(stylesheet => {
          head.push(_react.default.createElement("link", {
            type: "text/css",
            rel: "stylesheet",
            href: stylesheet
          }));
        });
        styles.forEach(style => {
          head.push(_react.default.createElement("style", null, style));
        });
      }

      this.setState({
        head: head
      });
    });
  }

  componentDidMount() {
    this.getHead();
  }

  render() {
    const className = this.props.className;
    const head = this.state.head;

    if (!head) {
      return false;
    }

    const template = '<!DOCTYPE html><html><head></head><body id="preview-iframe"></body></html>';
    return _react.default.createElement(_reactFrameComponent.default, {
      className: className,
      initialContent: template,
      head: head,
      mountTarget: "#preview-iframe",
      contentDidMount: this.iframeDidMount
    }, this.props.children);
  }

}

_defineProperty(IframeChildren, "defaultProps", {});

IframeChildren.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  children: _propTypes.default.node
} : {};
var _default = IframeChildren;
exports.default = _default;
module.exports = exports.default;